import React from 'react';
import classnames from 'classnames';
import { NavLink } from 'react-router-dom';
import PropTypes from 'prop-types';

import { URLS } from '../../../constants/constants';

import linkStyles from './logoLink.module.css';

export const LogoLink = ({
  variant,
  onClick,
  hasCustomMargin,
  linkMarginStyle,
  children,
}) => (
  <NavLink
    to={URLS.HOME}
    onClick={onClick}
    className={classnames(linkStyles.logoLink, {
      [linkStyles.logoLinkLogin]: variant === 'login' && !hasCustomMargin,
      [linkStyles.logoLinkSplash]: variant === 'splash' && !hasCustomMargin,
      [linkStyles.logoLinkLoader]: variant === 'loader' && !hasCustomMargin,
    })}
    style={linkMarginStyle}
  >
    {children}
  </NavLink>
);

LogoLink.propTypes = {
  variant: PropTypes.oneOf(['header', 'login', 'splash', 'loader']),
  onClick: PropTypes.func,
  hasCustomMargin: PropTypes.bool,
  linkMarginStyle: PropTypes.object,
  children: PropTypes.node.isRequired,
};
